import { Tournament } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { logger } from '@/src/core/utils';

/**
 * Joins the current user to a tournament by its invite code.
 *
 * Runs server-side (RPC join_tournament_by_code): RLS doesn't let users insert
 * themselves into participants, and the database checks the code, tournament
 * status, duplicates and capacity atomically for auth.uid().
 */
export class JoinTournamentByCodeUseCase {
  constructor(private invitationRepository: TournamentInvitationRepository) {}

  async execute(params: { code: string; userName: string }): Promise<Tournament> {
    const code = params.code.trim().toUpperCase();
    if (!code) {
      throw new Error('Invalid invite code');
    }

    logger.debug('JoinByCode', 'Joining tournament by invite code', { code });
    const tournament = await this.invitationRepository.joinByCode(code, params.userName.trim());
    logger.debug('JoinByCode', 'Joined tournament successfully', { tournamentId: tournament.id });

    return tournament;
  }
}
